import { Grid, Box, Typography, Tooltip, useTheme, Divider, Chip } from "@mui/material";
import LanOutlinedIcon from "@mui/icons-material/LanOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import NumbersOutlinedIcon from "@mui/icons-material/NumbersOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import {
	AccessTimeOutlined,
	AddIcCallOutlined,
	BusinessOutlined,
	DownloadOutlined,
	InfoOutlined,
	InventoryOutlined,
	LanguageOutlined,
	LocalPhoneOutlined,
	PeopleOutline,
	PersonOutlined,
	PinDropOutlined,
	RadarOutlined,
	RouterOutlined,
	StorageOutlined,
	UploadOutlined,
} from "@mui/icons-material";
import { maskCellPhone, maskPhone } from "../../../../../../utils/masks";
import dayjs from "dayjs";
import useStyles from "./styles";
import { CopyTexto } from "..";

// Seção "Formulario" do preview (read-only): Rede, Tipos de Entrega, Parceiro
// + Escalonamento, Velocidade, Cliente Final, POP e Regional, Equipamentos e
// Meio de Entrega — mesma fronteira aplicada ao modo edição na Task 6
// (FormularioTab). Observações Finais NÃO entra aqui: acompanha o container
// (previewData/index.js), como no modo edição (circuito/index.js). Extraído
// de previewData.js (Task 7 da decomposição), mesmo JSX/comportamento.
export default function FormularioPreview({ form, clientCpes, servico, setSnackbar }) {
	const theme = useTheme();
	const styles = useStyles(theme);
	const hostName = clientCpes?.[servico]?.find((h) => h?.hostid === form?.hostId)?.host;
	// Velocidade 0 e um valor valido: nao usar checagem por truthiness aqui
	const temValor = (valor) => valor !== null && valor !== undefined && valor !== "";

	function maskCelular(celular) {
		if (celular.length < 11) {
			return maskCellPhone(celular);
		} else {
			return maskPhone(celular);
		}
	}

	return (
		<>
			<Grid item xs={12} sx={styles.boxContent}>
				<LanguageOutlined color="primary" />
				<Typography variant="mySubtitle2">
					Configuração de Rede
				</Typography>
			</Grid>
			<Grid container spacing={1} columns={12}>
				{/* Linha 1 */}
				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<LanOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Bloco de IP:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.blockIP || "-", setSnackbar })
								}
							>
								{form?.blockIP || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							IP Público:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.ipPublico || "-", setSnackbar })
								}
							>
								{form?.ipPublico || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<NumbersOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>Serial:</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.serial || "-", setSnackbar })
								}
							>
								{form?.serial || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<DnsOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>VLAN ID:</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.vlanId || "-", setSnackbar })
								}
							>
								{form?.vlanId || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				{/* Linha 2 */}
				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							IPv4 - Local:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.companySideIPv4 || "-", setSnackbar })
								}
							>
								{form?.companySideIPv4 || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							IPv4 - Cliente:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.clientIPv4 || "-", setSnackbar })
								}
							>
								{form?.clientIPv4 || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							IPv6 - Local:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.companySideIPv6 || "-", setSnackbar })
								}
							>
								{form?.companySideIPv6 || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} smx={4} md={3}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							IPv6 - Cliente:
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={styles.typographyLabel}
								onClick={() =>
									CopyTexto({ campo: form?.clientIPv6 || "-", setSnackbar })
								}
							>
								{form?.clientIPv6 || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>
			</Grid>

			<Divider sx={styles.divider} />

			{/* Coluna 2 */}
			<Box sx={styles.boxContent}>
				<InventoryOutlined color="primary" />
				<Typography variant="mySubtitle2">Tipos de Entrega</Typography>
				<Tooltip title="Entregas lógicas: MPLS, L2, entre outras." arrow>
					<InfoOutlined
						sx={{
							color: theme.palette.tertiary.light,
							fontSize: 18,
							cursor: "pointer",
						}}
					/>
				</Tooltip>
			</Box>

			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Box sx={styles.boxCampos}>
						<Tooltip title="Clique para copiar">
							<Box sx={styles.boxChip}>
								{form?.serviceTypes?.map(
									(serviceType, index) =>
										serviceType?.value && (
											<Chip
												onClick={() =>
													CopyTexto({ campo: serviceType?.label, setSnackbar })
												}
												key={index}
												sx={styles.typographyLabel}
												label={serviceType?.label}
												size="small"
											/>
										),
								)}
							</Box>
						</Tooltip>
					</Box>
				</Grid>
			</Grid>

			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<PeopleOutline color="primary" />
				<Typography variant="mySubtitle2">Parceiro Last Mile</Typography>
			</Box>
			<Grid container spacing={1} columns={12}>
				{form?.lastMilePartner?.partnerEnabled && (
					<>
						<Grid item xs={12} sm={6}>
							<Box sx={styles.boxCampos}>
								<PersonOutlined sx={styles.icons} />
								<Typography sx={styles.typhographyTitle}>
									Nome do Parceiro:
								</Typography>
								<Tooltip title="Clique para copiar">
									<Typography
										sx={styles.typographyLabel}
										onClick={() =>
											CopyTexto({
												campo: form?.lastMilePartner?.partnerName || "-",
												setSnackbar,
											})
										}
									>
										{form?.lastMilePartner?.partnerName || "-"}
									</Typography>
								</Tooltip>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box sx={styles.boxCampos}>
								<LocalPhoneOutlined sx={styles.icons} />
								<Typography sx={styles.typhographyTitle}>
									Contato do Parceiro:
								</Typography>
								<Tooltip title="Clique para copiar">
									<Typography
										onClick={() =>
											CopyTexto({
												campo:
													maskCelular(
														form?.lastMilePartner?.partnerContact,
													) || "-",
												setSnackbar,
											})
										}
									>
										{maskCelular(form?.lastMilePartner?.partnerContact) ||
											"-"}
									</Typography>
								</Tooltip>
							</Box>
						</Grid>
					</>
				)}
			</Grid>
			<Box sx={styles.boxContent}>
				<AddIcCallOutlined color="primary" />
				<Typography variant="mySubtitle2">
					Contatos de escalonamento:
				</Typography>
			</Box>
			<Grid container spacing={1} columns={12}>
				{form?.lastMilePartner?.escalationContacts?.map(
					(escalationContact, index) => (
						<>
							<Grid item xs={12} sm={6} smx={4} md={3}>
								<Box sx={styles.boxCampos}>
									<PersonOutlined sx={styles.icons} />
									<Typography
										sx={styles.typhographyTitle}
									>{`Nome do Contato ${index + 1}:`}</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: escalationContact?.name || "-",
													setSnackbar,
												})
											}
										>
											{escalationContact?.name || "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6} smx={4} md={3}>
								<Box sx={styles.boxCampos}>
									<BusinessOutlined sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Cargo:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo: escalationContact?.role || "-",
													setSnackbar,
												})
											}
										>
											{escalationContact?.role || "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6} smx={4} md={3}>
								<Box sx={styles.boxCampos}>
									<LocalPhoneOutlined sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Contato:
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo:
														maskCelular(escalationContact?.phone) || "-",
													setSnackbar,
												})
											}
										>
											{maskCelular(escalationContact?.phone) || "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6} smx={4} md={3}>
								<Box sx={styles.boxCampos}>
									<AccessTimeOutlined sx={styles.icons} />
									<Typography sx={styles.typhographyTitle}>
										Tempo :
									</Typography>
									<Tooltip title="Clique para copiar">
										<Typography
											sx={styles.typographyLabel}
											onClick={() =>
												CopyTexto({
													campo:
														escalationContact?.escalationTime != null
															? dayjs()
																	.startOf("day")
																	.add(
																		escalationContact?.escalationTime,
																		"minute",
																	)
																	.format("HH:mm")
															: "-",
													setSnackbar,
												})
											}
										>
											{escalationContact?.escalationTime != null
												? dayjs()
														.startOf("day")
														.add(
															escalationContact?.escalationTime,
															"minute",
														)
														.format("HH:mm")
												: "-"}
										</Typography>
									</Tooltip>
								</Box>
							</Grid>
						</>
					),
				)}
			</Grid>
			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<SpeedOutlinedIcon color="primary" />
				<Typography variant="mySubtitle2">Velocidade:</Typography>
			</Box>
			<Grid container spacing={1} columns={12}>
				<Grid item xs={12} sm={6} lg={3}>
					<Box sx={styles.boxCampos}>
						<DownloadOutlined sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Download :
						</Typography>
						{temValor(form?.speed?.download) && (
							<Tooltip title="Clique para copiar">
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({
											campo: `${form?.speed?.download} Mbps` || "-",
											setSnackbar,
										})
									}
								>
									{`${form?.speed?.download} Mbps` || "-"}
								</Typography>
							</Tooltip>
						)}
					</Box>
				</Grid>
				<Grid item xs={12} sm={6} lg={3}>
					<Box sx={styles.boxCampos}>
						<UploadOutlined sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>Upload :</Typography>
						{temValor(form?.speed?.upload) && (
							<Tooltip title="Clique para copiar">
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({
											campo: `${form?.speed?.upload} Mbps` || "-",
											setSnackbar,
										})
									}
								>
									{`${form?.speed?.upload} Mbps` || "-"}
								</Typography>
							</Tooltip>
						)}
					</Box>
				</Grid>
				{form?.hostId && (
					<Grid item xs={12} sm={6} lg={3}>
						<Box sx={styles.boxCampos}>
							<RouterOutlined sx={styles.icons} />
							<Typography sx={styles.typhographyTitle}>Host:</Typography>
							<Tooltip title="Clique para copiar">
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({ campo: hostName || form?.hostId, setSnackbar })
									}
								>
									{hostName || form?.hostId}
								</Typography>
							</Tooltip>
						</Box>
					</Grid>
				)}
			</Grid>
			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<PersonOutlined color="primary" />
				<Typography variant="mySubtitle2">Cliente Final:</Typography>
				<Tooltip
					title="Aplicável quando somos o last mile do parceiro, sendo responsáveis pela entrega até o cliente final."
					arrow
				>
					<InfoOutlined
						sx={{
							color: theme.palette.tertiary.light,
							fontSize: 18,
							cursor: "pointer",
						}}
					/>
				</Tooltip>
			</Box>
			<Grid container spacing={1} columns={12}>
				<Grid item xs={12}>
					<Box sx={styles.boxCampos}>
						<PersonOutlined sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Nome do Cliente :
						</Typography>
						<Tooltip title="Clique para copiar">
							<Typography
								sx={{ ...styles.typographyLabel, maxWidth: "80%" }}
								onClick={() =>
									CopyTexto({
										campo: form?.endClient?.endClientName || "-",
										setSnackbar,
									})
								}
							>
								{form?.endClient?.endClientName || "-"}
							</Typography>
						</Tooltip>
					</Box>
				</Grid>
			</Grid>
			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<PinDropOutlined color="primary" />
				<Typography variant="mySubtitle2">POP e Regional:</Typography>
			</Box>
			<Grid container spacing={1} columns={12}>
				<Grid item xs={12} sm={6}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>POP :</Typography>
						{form?.pop?.tagName && (
							<Tooltip title="Clique para copiar">
								<Chip
									label={form?.pop?.tagName}
									size="small"
									sx={{
										...styles.typographyLabel,
										bgcolor: form?.pop?.color,
										color: theme.palette.white.main,
										":hover": {
											bgcolor: form?.pop?.color,
										},
									}}
									onClick={() =>
										CopyTexto({ campo: form?.pop?.tagName, setSnackbar })
									}
								/>
							</Tooltip>
						)}
					</Box>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Box sx={styles.boxCampos}>
						<PublicOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Regional :
						</Typography>
						{form?.regional?.tagName && (
							<Tooltip title="Clique para copiar">
								<Chip
									label={form?.regional?.tagName}
									size="small"
									sx={{
										bgcolor: form?.regional?.color,
										...styles.typographyLabel,
										color: theme.palette.white.main,
										":hover": {
											bgcolor: form?.regional?.color,
										},
									}}
									onClick={() =>
										CopyTexto({ campo: form?.regional?.tagName, setSnackbar })
									}
								/>
							</Tooltip>
						)}
					</Box>
				</Grid>
			</Grid>
			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<StorageOutlined color="primary" />
				<Typography variant="mySubtitle2">Equipamentos:</Typography>
			</Box>
			<Grid container spacing={1} columns={12}>
				<Grid item xs={12} sm={4}>
					<Box sx={styles.boxCampos}>
						<RouterOutlined sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Roteamento :
						</Typography>
						<Tooltip
							title="Realizado no PE ou BNG do cliente, conforme a arquitetura definida."
							arrow
						>
							<InfoOutlined
								sx={{
									color: theme.palette.tertiary.light,
									fontSize: 18,
									cursor: "pointer",
								}}
							/>
						</Tooltip>
						<Tooltip title="Clique para copiar">
							{form?.equipRouter?.map((item, index) => (
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({ campo: item?.label || "-", setSnackbar })
									}
								>
									{item?.label || "-"}
								</Typography>
							))}
						</Tooltip>
					</Box>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Box sx={styles.boxCampos}>
						<DnsOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							Entrega - Milha Final :
						</Typography>
						<Tooltip
							title="Último equipamento antes da entrega ao cliente, sob responsabilidade da operadora provedora do acesso."
							arrow
						>
							<InfoOutlined
								sx={{
									color: theme.palette.tertiary.light,
									fontSize: 18,
									cursor: "pointer",
								}}
							/>
						</Tooltip>
						<Tooltip title="Clique para copiar">
							{form?.equipDelivery?.map((item, index) => (
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({ campo: item?.label || "-", setSnackbar })
									}
								>
									{item?.label || "-"}
								</Typography>
							))}
						</Tooltip>
					</Box>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Box sx={styles.boxCampos}>
						<DnsOutlinedIcon sx={styles.icons} />
						<Typography sx={styles.typhographyTitle}>
							{"Milha Final (lado cliente):"}
						</Typography>
						<Tooltip
							title="Equipamento instalado na localidade do cliente, responsável pela terminação do serviço."
							arrow
						>
							<InfoOutlined
								sx={{
									color: theme.palette.tertiary.light,
									fontSize: 18,
									cursor: "pointer",
								}}
							/>
						</Tooltip>
						<Tooltip title="Clique para copiar">
							{form?.equipLastMile?.map((item, index) => (
								<Typography
									sx={styles.typographyLabel}
									onClick={() =>
										CopyTexto({ campo: item?.label || "-", setSnackbar })
									}
								>
									{item?.label || "-"}
								</Typography>
							))}
						</Tooltip>
					</Box>
				</Grid>
			</Grid>
			<Divider sx={styles.divider} />
			<Box sx={styles.boxContent}>
				<RadarOutlined color="primary" />
				<Typography variant="mySubtitle2">Meio de Entrega:</Typography>
				<Tooltip
					title="Entrega física, podendo ser realizada por: Fibra óptica, Rádio, Cabo AS, entre outras"
					arrow
				>
					<InfoOutlined
						sx={{
							color: theme.palette.tertiary.light,
							fontSize: 18,
							cursor: "pointer",
						}}
					/>
				</Tooltip>
			</Box>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Box sx={styles.boxCampos}>
						<Tooltip title="Clique para copiar">
							<Box sx={styles.boxChip}>
								{form?.deliveryMedium?.map(
									(serviceType, index) =>
										serviceType?.value && (
											<Chip
												sx={styles.typographyLabel}
												onClick={() =>
													CopyTexto({ campo: serviceType?.label, setSnackbar })
												}
												key={index}
												label={serviceType?.label}
												size="small"
											/>
										),
								)}
							</Box>
						</Tooltip>
					</Box>
				</Grid>
			</Grid>
		</>
	);
}
